import { SubscriptionName } from '@anm/api/modules/subscription';

const isFreeSubscription = (subscription: SubscriptionName) =>
  subscription === 'WaveFree';

export default isFreeSubscription;
